import React, {Suspense, lazy} from "react";
import {
	Outlet,
	Route,
	createRoutesFromElements,
	isRouteErrorResponse,
	useRouteError,
	Routes,
} from "react-router-dom";
import PrivateLayout from "../Layout/Private";
import NoFoundPage from "../pages/NoFound";
import InternalError from "../pages/Error";
import {ROUTES} from "./routes";
import RequiredAuth from "../component/SecureRoute";
import {LoginCallback} from "@okta/okta-react";
import EmployeeLeaderboards from "../pages/EmployeeLeaderboards";
import SiteLeaderboards from "../pages/SiteLeaderboards";

const ProvidersLayout = () => {
	return (
		<Suspense>
			<Outlet />
		</Suspense>
	);
};

const PrivateRootErrorElement = () => {
	const error = useRouteError();

	if (isRouteErrorResponse(error)) {
		if (error.status === 404) {
			return <NoFoundPage />;
		}
		return <InternalError />;
	}

	return null;
};

const MyProfile = lazy(() => import("../pages/Home"));
const Churn = lazy(() => import("../pages/Churn"));
const Revenue = lazy(() => import("../pages/Revenue"));
const WashRedemtion = lazy(() => import("../pages/WashRedemtion"));
const MembershipSnapshot = lazy(() => import("../pages/MembershipSnapshot"));
const MembershipTimeline = lazy(() => import("../pages/MembershipTimeline"));
const MembershipProfiles = lazy(() => import("../pages/MembershipProfiles"));
const Marketing = lazy(() => import("../pages/Marketing"));
const Retail = lazy(() => import("../pages/Retail"));
const LeaderBoard = lazy(() => import("../pages/Leaderboards"));
const Ticketing = lazy(() => import("../pages/Ticketing"));
const TicketViewWrapper = lazy(() => import("../pages/TicketViewWrapper"));
const RegionalTargets = lazy(() => import("../pages/RegionalTargets"));

const protected_routes = (
	<Routes>
		<Route
			element={<ProvidersLayout />}
			errorElement={<PrivateRootErrorElement />}
		>
			<Route element={<RequiredAuth />}>
				<Route element={<PrivateLayout />}>
					<Route path={ROUTES.MYPROFILE} element={<MyProfile />} />
					<Route path={ROUTES.CHURN} element={<Churn />} />
					<Route path={ROUTES.REVENUE} element={<Revenue />} />
					<Route path={ROUTES.WASHREDEMPTION} element={<WashRedemtion />} />
					<Route
						path={ROUTES.MEMBERSHIPSNAPSHOT}
						element={<MembershipSnapshot />}
					/>
					<Route
						path={ROUTES.MEMBERSHIPTIMELINE}
						element={<MembershipTimeline />}
					/>
					<Route
						path={ROUTES.MEMBERSHIPROFILES}
						element={<MembershipProfiles />}
					/>
					<Route path={ROUTES.MARKETING} element={<Marketing />} />
					<Route path={ROUTES.RETAIL} element={<Retail />} />
					<Route path={ROUTES.TICKETING} element={<Ticketing />} />
					<Route path={ROUTES.TICKETVIEW} element={<TicketViewWrapper />} />
					<Route
						path={ROUTES.EMPLOYEE_LEADERBOARDS}
						element={<EmployeeLeaderboards />}
					/>
					<Route
						path={ROUTES.SITE_LEADERBOARDS}
						element={<SiteLeaderboards />}
					/>
					<Route path={ROUTES.REGIONAL_TARGETS} element={<RegionalTargets />} />
				</Route>
			</Route>
			<Route path={"/callback"} element={<LoginCallback />} />
			<Route path={ROUTES.LEADERBOARDS} element={<LeaderBoard />} />
		</Route>
	</Routes>
);

export default protected_routes;
